/**
 * A new Zod rule does not apply to a form that is already submitted or approved.
 * Amend and QA save still run validation, so the rule would block that save.
 * The caller decides whether to call `ctx.addIssue`.
 */
const SUBMITTED_OR_APPROVED = ['SUBMITTED', 'APPROVED'];
export function isSubmittedOrApproved(formStatus) {
    return !!formStatus && SUBMITTED_OR_APPROVED.includes(formStatus);
}
